/**
 * HTML文字列からタグを削除してプレーンテキストにする
 * @param {string} html - HTML文字列
 * @returns {string} プレーンテキスト
 */
export const stripHtml = (html) => {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, '') // HTMLタグを削除
    .replace(/&nbsp;/g, ' ') // &nbsp;をスペースに変換
    .replace(/&amp;/g, '&') // &amp;を&に変換
    .replace(/&lt;/g, '<') // &lt;を<に変換
    .replace(/&gt;/g, '>') // &gt;を>に変換
    .replace(/&quot;/g, '"') // &quot;を"に変換
    .replace(/&#39;/g, "'") // &#39;を'に変換
    .replace(/\s+/g, ' ') // 連続する空白を1つに
    .trim(); // 前後の空白を削除
};

/**
 * テキストを指定の長さに切り詰める
 * @param {string} text - 元のテキスト
 * @param {number} maxLength - 最大文字数
 * @returns {string} 切り詰められたテキスト
 */
export const truncateText = (text, maxLength = 160) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;

  // maxLengthより前で最後の句読点を探す
  const truncated = text.substring(0, maxLength);
  const lastPunctuation = Math.max(
    truncated.lastIndexOf('。'),
    truncated.lastIndexOf('、'),
    truncated.lastIndexOf('.')
  );

  // 句読点が見つかった場合はそこで切る、見つからない場合はmaxLengthで切る
  if (lastPunctuation > maxLength * 0.5) {
    return text.substring(0, lastPunctuation + 1);
  }

  return truncated + '...';
};

/**
 * HTML文字列から説明文を生成する
 * @param {string} html - HTML文字列
 * @param {number} maxLength - 最大文字数
 * @returns {string} 説明文
 */
export const generateExcerpt = (html, maxLength = 160) => {
  const plainText = stripHtml(html);
  return truncateText(plainText, maxLength);
};

/**
 * 絶対URLを生成する
 * @param {string} path - 相対パス
 * @param {string} siteUrl - サイトのベースURL
 * @returns {string} 絶対URL
 */
export const getAbsoluteUrl = (path, siteUrl) => {
  if (!path) return siteUrl;
  if (path.startsWith('http')) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${siteUrl}${cleanPath}`;
};

/**
 * 画像URLを絶対URLに変換する
 * @param {string} imageUrl - 画像URL
 * @param {string} siteUrl - サイトのベースURL
 * @returns {string} 絶対URL
 */
export const getAbsoluteImageUrl = (imageUrl, siteUrl) => {
  if (!imageUrl) return `${siteUrl}/images/favicon.jpg`;
  if (imageUrl.startsWith('http')) return imageUrl;

  const cleanPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  return `${siteUrl}${cleanPath}`;
};
